export const computeAssetTickerMic = (asset) => {
  if (!asset) { return null }

  const { ticker, exchange } = asset
  return ticker && exchange ? { ticker, mic: exchange } : null
}
